import React, { useState, useContext, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { CaptureContext, ModuloContext, SellerContext } from '../context/seller_context';
import { useZxing } from 'react-zxing';
import '../assets/styles/qr_reader_view.css';

const QrReaderView = () => {
    const moduloContext = useContext(ModuloContext);
    const captureContext = useContext(CaptureContext);
    const navigate = useNavigate();
    const [error, setError] = useState<string | null>(null);
    const [isProcessing, setIsProcessing] = useState(false);
    const { setModule } = moduloContext!;
    const streamRef = useRef<MediaStream | null>(null);
    const cameraInitialized = useRef(false);

    const { setCapturedImageC, hasCapturedImageC } = captureContext!;

    // Timer to redirect to home after 55 seconds
    useEffect(() => {
        const timeout = setTimeout(() => {
            navigate('/home');
        }, 55000);
        return () => clearTimeout(timeout);
    }, [navigate]);

    useEffect(() => {
        setCapturedImageC(null);
    }, [setCapturedImageC]);

    const isMobileDevice = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

    useEffect(() => {
        const startCamera = async () => {
            if (cameraInitialized.current) return;
            cameraInitialized.current = true;

            try {
                if (!isMobileDevice) {
                    console.log("Dispositivo no móvil, no se intentará acceder a la cámara trasera");
                    return;
                }

                // Stop the current stream if it exists
                if (streamRef.current) {
                    streamRef.current.getTracks().forEach(track => track.stop());
                }

                const mediaStream = await navigator.mediaDevices.getUserMedia({
                    video: {
                        facingMode: { exact: "environment" },
                        width: { ideal: 1920 },
                        height: { ideal: 1080 },
                        frameRate: { ideal: 30 }
                    },
                });

                streamRef.current = mediaStream;

                const devices = await navigator.mediaDevices.enumerateDevices();
                const videoTrack = mediaStream.getVideoTracks()[0];
                const cameraDevice = devices.find(
                    (device) => device.deviceId === videoTrack.getSettings().deviceId
                );

                if (cameraDevice) {
                    console.log("Cámara seleccionada:", cameraDevice.label);
                }

            } catch (err: any) {
                if (isMobileDevice) {
                    console.error("Error al acceder a la cámara:", err);
                    setError("Error al acceder a la cámara: " + err.message);
                }
            }
        };

        startCamera();

        return () => {
            if (streamRef.current) {
                streamRef.current.getTracks().forEach(track => track.stop());
                cameraInitialized.current = false;
            }
        };
    }, [isMobileDevice]);

    const { ref } = useZxing({
        onDecodeResult(result) {
            handleQRCodeScanModule(result.getText());
        },
        timeBetweenDecodingAttempts: 500,
    });

    if (!moduloContext) {
        return <div>Error: ModuloContext no está definido</div>;
    }

    const handleQRCodeScanModule = (data: string | null) => {
        if (data && !isProcessing) {
            setIsProcessing(true);
            try {
                const qrData = JSON.parse(data);
                setModule(qrData);
                navigate('/seller_profile');
            } catch (error) {
                setError('Error al procesar el código QR');
            } finally {
                setTimeout(() => setIsProcessing(false), 2000);
            }
        }
    };

    return (
        <div className="scan-qr-code">
            <div className="qr-container">
                <h2>Escanear código QR del Módulo</h2>
                <div className="qr-preview">
                    <div className="qr-preview-video">
                        <video
                            ref={ref as any}
                            autoPlay
                            playsInline
                            muted
                        />
                        {cameraInitialized.current == false && <div className="camera-loading-overlay">Inicializando cámara...</div>}
                    </div>
                    <div className="corner top-right"></div>
                    <div className="corner bottom-left"></div>
                </div>
                {error && <p className="error-message">{error}</p>}
            </div>
        </div>
    );
};

export default QrReaderView;